import React from 'react';
import { Drawer, Box, Typography, IconButton, Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoaderComponent from 'components/Loader';
import { formatNumberWithCommas } from 'utils/common-util';
import { useTheme } from "@mui/material/styles";
import MetricCardWidget from 'components/Widgets/MetricCardWidget';

interface FinOpsCostBreakupDrawerProps {
	open: boolean;
	onClose: () => void;
	data: any;
	loading: boolean;
	title: any;
}

const FinOpsCostBreakupDrawer: React.FC<FinOpsCostBreakupDrawerProps> = ({ open, onClose, data, loading, title }) => {
	const theme = useTheme();
	const colors = theme.palette;

	const formatNumberByUnits = (number: number) => {
		if (number >= 1000000) {
			return `${new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
				number / 1000000
			)} MM`;
		}
		if (number >= 1000) return `${formatNumberWithCommas((number / 1000).toFixed(2), true)} K`;
		return new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(number);
	};

	function formatAbsNumber(number: any) {
		if (number != null && !isNaN(number) && number != 0) {
			const absNumber = Math.abs(number);
			return absNumber % 1 === 0
				? absNumber.toLocaleString('en-US', { maximumFractionDigits: 0 }) // No decimals for whole numbers
				: absNumber.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); // Show decimals if needed
		}
		return '0';
	}

	return (
		<Drawer anchor="right" open={open} onClose={onClose}>
			<Box sx={{ width: 390, bgcolor: `${colors.backgroundLight.primary} !important`, color: 'white', p: 2, height: '100%', overflowY: 'auto' }}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography sx={{ fontSize: '14px', fontStyle: 'italic', fontWeight: '500', color: `${colors.textLight.main} !important` }}>
						{title}
					</Typography>
					<IconButton onClick={onClose} sx={{ color: `${colors.textLight.main} !important` }}>
						<CloseIcon sx={{ color: `${colors.textLight.main} !important` }} />
					</IconButton>
				</Box>
				<Divider sx={{ my: 1, borderColor: '#71758F !important' }} />

				{loading ? (
					<LoaderComponent />
				) : (
					<Grid container gap={2}>
						{data.map((item: any, idx: any) => (
							<Grid item xs={12} key={item.title || idx}>
								<MetricCardWidget
									minTitleHeight="23px"
									title={item.title}
									number={'$' + formatNumberByUnits(item.value)}
									isLoading={false}
									tooltipLabel=""
									hasTooltip={false}
									change={0}
									changeType=''
								// change={formatAbsNumber(item.change)}
								// changeType={
								// 	item.change == null
								// 		? ''
								// 		: parseFloat(item.change) > 0
								// 		? 'increase'
								// 		: parseFloat(item.change) < 0
								// 		? 'decrease'
								// 		: ''
								// }
								/>
							</Grid>
						))}
					</Grid>
				)}
			</Box>
		</Drawer>
	);
};

export default FinOpsCostBreakupDrawer;
